import { useMemo } from 'react';
import { assetTokenRatesAtom } from '../../../atoms/lendAndBorrow';
import { useAtom } from '../../../lib';
import Icon from '../Icon';
import Typography from '../Typography';

import './OracleUnavailableBanner.scss';

const OracleUnavailableBanner = () => {
  const [assetTokenRates] = useAtom(assetTokenRatesAtom);

  const unavailable = assetTokenRates.unavailableAssets;

  const label = useMemo(() => {
    if (!unavailable.length) return null;

    const tickers = unavailable.join(', ');
    return unavailable.length === 1
      ? `Price data for ${tickers} is temporarily unavailable due to an on-chain oracle issue. Displayed values may be incomplete.`
      : `Price data for ${tickers} is temporarily unavailable due to on-chain oracle issues. Displayed values may be incomplete.`;
  }, [unavailable]);

  if (!unavailable.length) return null;

  return (
    <div className="nostra__oracleUnavailableBanner">
      <Icon variant="alert" size={20} color="--icon-default-darkbg" />
      <Typography variant="body-md" color="text-primary-darkbg">
        {label}
      </Typography>
    </div>
  );
};

export default OracleUnavailableBanner;
